// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-header {
  color: #fff;
  text-align: center;
}
.content-header img {
  width: 130px;
  height: 130px;
  border-radius: 50%;
}
.content-header h1 {
  font-size: 36px;
  font-weight: 400;
  margin: 0;
}
.content-header h4 {
  font-size: 16px;
  font-weight: 300;
  max-width: 580px;
  text-align: center;
  margin: 0 auto;
}
.content-header.bg-image {
  background-image: url('header-bg.6c5262d2bca37239.png');
  background-blend-mode: overlay;
  background-size: 300px;
}

@media screen and (min-width: 960px) {
  .content-header img {
    width: 150px;
    height: 150px;
  }
  .content-header h1 {
    font-size: 48px;
  }
  .content-header h4 {
    font-size: 18px;
  }
  .content-header.has-bg-image {
    background-size: 480px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared-component/ui-shared/content-header/content-header.component.scss"],"names":[],"mappings":"AAGA;EACI,WAAA;EACA,kBAAA;AAFJ;AAGI;EACI,YAAA;EACA,aAAA;EACA,kBAAA;AADR;AAGI;EACI,eAAA;EACA,gBAAA;EACA,SAAA;AADR;AAGI;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AADR;AAGI;EACI,uDAAA;EACA,8BAAA;EACA,sBAAA;AADR;;AAMA;EAEQ;IACI,YAAA;IACA,aAAA;EAJV;EAMM;IACI,eAAA;EAJV;EAMM;IACI,eAAA;EAJV;EAMM;IACI,sBAAA;EAJV;AACF","sourcesContent":["// ==========================================================================\r\n// Component: Content-header.component\r\n// ==========================================================================\r\n.content-header{\r\n    color: #fff;\r\n    text-align: center;\r\n    img{\r\n        width: 130px;\r\n        height: 130px;\r\n        border-radius: 50%;\r\n    }\r\n    h1{\r\n        font-size: 36px;\r\n        font-weight: 400;\r\n        margin: 0;\r\n    } \r\n    h4{\r\n        font-size: 16px;\r\n        font-weight: 300;\r\n        max-width: 580px;\r\n        text-align: center;\r\n        margin: 0 auto;\r\n    }\r\n    &.bg-image{\r\n        background-image: url(\"../../../../assets/img/app/header-bg.png\");     \r\n        background-blend-mode: overlay;\r\n        background-size: 300px; \r\n    }\r\n}\r\n\r\n\r\n@media screen and (min-width: 960px) {    \r\n    .content-header{\r\n        img{\r\n            width: 150px;\r\n            height: 150px;\r\n        }\r\n        h1{\r\n            font-size: 48px;\r\n        } \r\n        h4{\r\n            font-size: 18px;\r\n        }\r\n        &.has-bg-image{\r\n            background-size: 480px; \r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
